import { Card } from "semantic-ui-react";
import { NewParentChildListPageComponent } from "../components/page/NewParentChildListPageComponent";
import { getEventMetadata, getSession } from "../helper";
import {
  CREATE_ORGANIZATION,
  DELETE_ORGANIZATION_API_CALL,
  LIST_ORGANIZATIONS,
  UPDATE_ORGANIZATION,
} from "./routes";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import { getOrganizationForm } from "./organization_form";

const OrganizationCard = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid key={props.data.id}>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <Card.Header style={{ fontSize: 18 }}>
            <b>{props.data.name}</b>
          </Card.Header>
          <CardDotMenuComponent
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
            cardData={props.data}
            props={{
              menuItems: [
                {
                  type: "api_call",
                  label: "Delete",
                  apiCall: DELETE_ORGANIZATION_API_CALL,
                  callback: (
                    data: any,
                    setReloadKey: any,
                    pageData: any,
                    setPageData: any,
                  ) => {
                    setReloadKey((prev: number) => prev + 1);
                  },
                  apiCallVariables: (data: any) => {
                    return {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                      isChildElement: true,
                    };
                  },
                  showMenuOption: (data: any) => {
                    return data.hasChildren === false;
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Delete",
                  apiCall: DELETE_ORGANIZATION_API_CALL,
                  modalHeader: "Choose Delete Strategy for " + props.data.name,
                  showMenuOption: (data: any) => {
                    return data.hasChildren && data.parentOrganization;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      type: "single_form",
                      formFields: [
                        {
                          type: "radio_button",
                          key: "parentDeletionStrategy",
                          label:
                            "When deleting this organization, what should be done with its children?",
                          options: [
                            {
                              value: "delete_all",
                              label: "Delete all children",
                            },
                            {
                              value: "orphan_children",
                              label:
                                "Keep all children, but with no parent organization",
                            },
                            {
                              value: "promote_children",
                              label:
                                "Promote all children to be children of this organization's parent organization",
                            },
                          ],
                        },
                      ],
                    },
                    startingData: {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                      isChildElement: false,
                      parentDeletionStrategy: "delete_all",
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((prev: number) => prev + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Delete",
                  apiCall: DELETE_ORGANIZATION_API_CALL,
                  modalHeader: "Choose Delete Strategy for " + props.data.name,
                  showMenuOption: (data: any) => {
                    return data.hasChildren && !data.parentOrganization;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      type: "single_form",
                      formFields: [
                        {
                          type: "radio_button",
                          key: "parentDeletionStrategy",
                          label:
                            "When deleting this organization, what should be done with its children?",
                          options: [
                            {
                              value: "delete_all",
                              label: "Delete all children",
                            },
                            {
                              value: "orphan_children",
                              label:
                                "Keep all children, but with no parent organization",
                            },
                          ],
                        },
                      ],
                    },
                    startingData: {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                      isChildElement: false,
                      parentDeletionStrategy: "delete_all",
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((prev: number) => prev + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Edit",
                  modalHeader: "Edit Organization",
                  apiCall: {
                    documentNode: UPDATE_ORGANIZATION,
                    key: "updateOrganization",
                  },
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  callback: (data: any) => {
                    props.setReloadKey((prev: number) => prev + 1);
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: getOrganizationForm(),
                      type: "single_form",
                    },
                    startingData: {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                      parentOrganizationId:
                        props.data.parentOrganization?.id || undefined,
                      name: props.data.name,
                      childOrganizationIds: props.data.children.map(
                        (child: any) => child.id,
                      ),
                    },
                  }),
                },
              ],
            }}
          />
        </div>
      </Card.Content>
      <Card.Content className="children-elements">
        {props.data.children.map((childOrganization: any) => {
          return (
            <OrganizationCard
              key={childOrganization.id}
              data={childOrganization}
              setReloadKey={props.setReloadKey}
              pageData={props.pageData}
              setPageData={props.setPageData}
            />
          );
        })}
      </Card.Content>
    </Card>
  );
};

export const NewOrganizationsPage = () => {
  return (
    <NewParentChildListPageComponent
      props={{
        type: "parent_child_list",
        query: {
          documentNode: LIST_ORGANIZATIONS,
          key: "listOrganizations",
        },
        queryVariables: {
          session: getSession(),
        },
        itemName: "Organization",
        parentItem: "parentOrganization",
        card: OrganizationCard,
        creationProps: {
          formComponentProps: new NewNewFormComponentProps({
            form: {
              type: "single_form",
              formFields: getOrganizationForm(),
            },
            startingData: {
              name: "",
            },
          }),
          apiCall: {
            documentNode: CREATE_ORGANIZATION,
            key: "createOrganization",
          },
        },
      }}
    />
  );
};
